import { connect } from 'react-redux'
import { 
  getViewportHeight, 
  getDocumentHeight,
  getViewMode } from '../app/selectors'
import { backgroundUpdateCurrentRow } from '../background-canvas/actions'
import CollectionList from './collection-list'

const mapStateToProps = state => {
  return {
    viewMode: getViewMode(state),
    vh: getViewportHeight(state),
    dh: getDocumentHeight(state)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onUpdateIndex: index => {
      dispatch(backgroundUpdateCurrentRow(index))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CollectionList)



// WEBPACK FOOTER //
// ./src/components/collection-list/index.js